// extracted by mini-css-extract-plugin
export default {"label_spec":"SubmissionSuccess_label_spec__1rWR3","successBanner":"SubmissionSuccess_successBanner__n8fDY"};